import React from 'react';
import {PlusOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import cn from 'classnames';

import cls from './Question.module.scss'

interface Props {
    question: React.ReactNode
    answer: React.ReactNode
    color?: 'white'|'pink'|'black'|'gray'
    shadow?: boolean
    className?: string
    style?: any
}

export const Question = ({question, answer, color = 'white', className, style}: Props) => {

    const [open, setOpen] = React.useState(false);

    return (
    <div style={style} className={cn([
        cls.card,
        color==='white' && cls.white,
        color==='pink' && cls.pink,
        color==='black' && cls.black,
        color==='gray' && cls.gray,
        className && className,
    ])}>
        <div className={cls.top}>
            <div>{question}</div>
            <div>
                <Button
                    className={cn([cls.plus, open && cls.opened])}
                    type={'primary'}
                    onClick={() => setOpen(!open)}
                    shape={'circle'}
                    icon={<PlusOutlined style={{transition: 'all 300ms ease-in-out', transform: open ? 'rotate(45deg)' : 'rotate(0)'}}/>}
                />
            </div>
        </div>
        <div className={cls.bottom} style={{maxHeight: open ? 500 : 0}}>
            {open && answer}
        </div>
    </div>
)}